import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../components/shared/AuthContext';

export default function TeamChallengesPage() {
  const { orgId } = useParams();
  const { apiClient } = useContext(AuthContext);
  const [items, setItems] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [title, setTitle] = useState('');
  const [target, setTarget] = useState(50);
  const [objectiveType, setObjectiveType] = useState('QUESTION_READ');
  const [error, setError] = useState('');

  const load = () => apiClient.get(`/api/organizations/${orgId}/challenges`).then((r) => setItems(r.data || []));

  useEffect(() => { load().catch(() => setError('Could not load challenges.')); }, [apiClient, orgId]);

  const create = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await apiClient.post(`/api/organizations/${orgId}/challenges`, {
        title,
        objectiveType,
        targetValue: Number(target),
      });
      setTitle('');
      setShowCreateForm(false);
      load();
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.message || 'Could not create challenge.');
    }
  };

  return (
    <>
      {error && (
        <div className="teams-card">
          <div className="teams-error" role="alert">{error}</div>
        </div>
      )}
      {showCreateForm && (
        <div className="teams-card">
          <h2>New challenge</h2>
          <p className="teams-sub">
            Team members get a notification to opt in. Only accepted members contribute to the team counter.
          </p>
          <form onSubmit={create}>
            <div className="teams-form-row">
              <label htmlFor="c-title">Title</label>
              <input id="c-title" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </div>
            <div className="teams-form-row">
              <label htmlFor="c-type">Objective</label>
              <select id="c-type" value={objectiveType} onChange={(e) => setObjectiveType(e.target.value)}>
                <option value="QUESTION_READ">Questions read (team total)</option>
                <option value="PRACTICE_COUNT">Practice grades (team total)</option>
              </select>
            </div>
            <div className="teams-form-row">
              <label htmlFor="c-target">Team target</label>
              <input id="c-target" type="number" min={1} value={target} onChange={(e) => setTarget(e.target.value)} />
            </div>
            <div className="teams-form-actions">
              <button type="button" className="teams-btn teams-btn--secondary" onClick={() => setShowCreateForm(false)}>
                Cancel
              </button>
              <button type="submit" className="teams-btn">Launch challenge</button>
            </div>
          </form>
        </div>
      )}
      <div className="teams-card">
        <div className="teams-page-toolbar">
          <div>
            <h2>Challenges</h2>
            <p className="teams-sub">Team-wide counters for reads or practice while active.</p>
          </div>
          <button type="button" className="teams-btn" onClick={() => setShowCreateForm(true)}>
            New challenge
          </button>
        </div>
        {items.length === 0 ? (
          <p className="teams-sub">No challenges yet.</p>
        ) : (
          items.map((c) => (
            <div key={c.id} className="teams-assignment-row">
              <strong>{c.title}</strong>
              <span className="teams-badge">{c.status}</span>
              {c.myParticipationStatus === 'PENDING' && (
                <span className="teams-badge teams-badge--warn">Accept in Requests</span>
              )}
              <div className="teams-progress" style={{ marginTop: 8 }}>
                <div className="teams-progress-track">
                  <div className="teams-progress-fill" style={{ width: `${c.percentComplete ?? 0}%` }} />
                </div>
                <span className="teams-sub">
                  {c.progressValue}/{c.targetValue} · {c.objectiveType} · {c.percentComplete ?? 0}%
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}
